export const BILLING_CONFIG = (COMMUNITY_ID: string) =>
  `v1/communities/${COMMUNITY_ID}/pricing`;
export const PROPERTIES = (COMMUNITY_ID: string) => `v1/community/${COMMUNITY_ID}/properties`;
